/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Programmatic_Seo_Tlm_0Inputs */

const en_svc_programmatic_seo_tlm_0 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`page_engine`)
};

const ar_svc_programmatic_seo_tlm_0 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محرك الصفحات`)
};

const bn_svc_programmatic_seo_tlm_0 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পৃষ্ঠা ইঞ্জিন`)
};

const de_svc_programmatic_seo_tlm_0 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seiten-Engine`)
};

const es_svc_programmatic_seo_tlm_0 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motor de páginas`)
};

const fr_svc_programmatic_seo_tlm_0 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moteur de pages`)
};

const pt_svc_programmatic_seo_tlm_0 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motor de páginas`)
};

const zh_svc_programmatic_seo_tlm_0 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`页面引擎`)
};

const tr_svc_programmatic_seo_tlm_0 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sayfa motoru`)
};

const ru_svc_programmatic_seo_tlm_0 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Движок страниц`)
};

const pl_svc_programmatic_seo_tlm_0 = /** @type {(inputs: Svc_Programmatic_Seo_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Silnik stron`)
};

/**
* | output |
* | --- |
* | "page_engine" |
*
* @param {Svc_Programmatic_Seo_Tlm_0Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_programmatic_seo_tlm_0 = /** @type {((inputs?: Svc_Programmatic_Seo_Tlm_0Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Programmatic_Seo_Tlm_0Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_programmatic_seo_tlm_0(inputs)
	if (locale === "bn") return bn_svc_programmatic_seo_tlm_0(inputs)
	if (locale === "de") return de_svc_programmatic_seo_tlm_0(inputs)
	if (locale === "es") return es_svc_programmatic_seo_tlm_0(inputs)
	if (locale === "fr") return fr_svc_programmatic_seo_tlm_0(inputs)
	if (locale === "pt") return pt_svc_programmatic_seo_tlm_0(inputs)
	if (locale === "zh") return zh_svc_programmatic_seo_tlm_0(inputs)
	if (locale === "tr") return tr_svc_programmatic_seo_tlm_0(inputs)
	if (locale === "ru") return ru_svc_programmatic_seo_tlm_0(inputs)
	if (locale === "pl") return pl_svc_programmatic_seo_tlm_0(inputs)
	return en_svc_programmatic_seo_tlm_0(inputs)
});
export { svc_programmatic_seo_tlm_0 as "svc_programmatic-seo_tlm_0" }